
import React, { useEffect, useState } from "react";
import datas from "../../../assets/img/data.png";
import CompanyLogo from "../../../assets/img/Lighcast_RGB_Lockup_White.png";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";

const DashboardOverview = () => {


  const [loadingImages, setLoadingImages] = useState(true);

  useEffect(() => {
    const img = new window.Image();
    img.src = datas;
    img.onload = () => setLoadingImages(false);
  }, []);

  return (
    <>
      {
        loadingImages &&
        <LoadingScreen />
      }
      <h1 className="fw-bolder text-secondary-lc mt-5 mb-0 text-center overview__title">Welcome to Global Solution Workbench</h1>
      <section className="overview overflow-hidden d-flex align-items-stretch">
        <Container>
          <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-2 w-100">
            <Col xs={12} className="text-center cont">
              <div className="overview__content">
                <Image className="overview__content__image" src={datas} />
                <div className="overview__content__text">
                    <div className="info">
                      <b>Your solutions</b>
                      <p>
                        Discover data in a new way with interactive dashboards.<br/>
                        Turn complex information into clear, actionable insights.<br/>
                        A smart solution crafted by Lightcast
                      </p>
                    </div>
                    <div className="overview__content__powering">
                      <p>Powered by</p>
                      <a href="https://lightcast.io" target="_blank" rel="noopener noreferrer">
                        <Image src={CompanyLogo} alt="Lightcast" />
                      </a>
                    </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DashboardOverview;